'use strict';
const angular = require('angular');

export class datatableViewerComponent {
  constructor(DTOptionsBuilder, $timeout) {
    'ngInject';

    this.DTOptionsBuilder = DTOptionsBuilder;
    this.$timeout = $timeout;
  }

  $onInit() {
    this.data = this.resolve.config.data;
    this.settings = this.resolve.config.settings;
    this.name = this.resolve.config.name;

    this.dtOptions = {
      dom: 'lBfrtip',
      responsive: true,
      hasBootstrap: true,
      buttons: [{
        extend: 'excel',
        title: this.name
      },{
        extend: 'csv',
        title: this.name
      },{
        title: this.name,
        extend: 'pdf',
        orientation: 'portrait',
        pageSize: 'LETTER'
      },'print']
    };
  };
}

export default angular.module('conduu.datatableViewer', [])
  .component('datatableViewer', {
    template: require('./datatable-view.component.html'),
    bindings: {
      resolve: '<',
      config: '<',
      close: '&',
      dismiss: '&'
    },
    controller: datatableViewerComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/datatable-view/datatable-view.component.js